import React from "react";
import FormGroup from "../../../../components/common/FormGroup/FormGroup";
import CheckBox from "../../../../components/common/checkbox/Checkbox";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../constants/Routes";

const SignUp = () => {
  return (
    <>
      <h3 className="text-[1.5rem] 2xl:text-[2.5rem] font-poppins font-semibold leading-normal">Admin felület</h3>
      <h4 className="text-[1.2rem] 2xl:text-[1.5rem] font-poppins font-semibold leading-normal mb-8 2xl:mb-12">
        Regisztráció
      </h4>
      <FormGroup type={"text"} label={"Email cím"} id={"email"} name={"email"} placeHolder={`tesztelo@example.com`} />
      <FormGroup
        type={"password"}
        label={"Jelszó megadása"}
        id={"password"}
        name={"passsword"}
        placeHolder={`.................`}
      />
      <FormGroup
        type={"password"}
        label={"Jelszó újra"}
        id={"confirm-password"}
        name={"confirm-password"}
        placeHolder={`.................`}
      />

      <div className="flex flex-col gap-10 md:gap-2 md:mb-0 md:flex-row">
        <div className="w-full md:w-1/2">
          <CheckBox label={"Maradjon bejelentkezve"} />
        </div>
        <div className="w-full md:w-1/2">
          <Link to={ROUTES.ADMIN_HOME}>
            <ButtonFluid label={"Registráció"} />
          </Link>
        </div>
      </div>
    </>
  );
};

export default SignUp;
